<template>
    <div>
        <g-card>
            <g-row type="flex" justify="space-between" align="middle">
                <g-column>
                    <g-typography tag="p" font-weight="semibold" :value="displayName" />
                </g-column>

                <g-column>
                    <g-icon
                        v-if="current"
                        data-testid="current-icon"
                        name="check-circle"
                        type="solid"
                        color="green-5"
                    />
                    <g-button
                        v-else
                        data-testid="switch"
                        shape="round"
                        type="transparent"
                        theme="live"
                        size="large"
                        @click="handleSwitch()"
                    >
                        Switch
                    </g-button>
                </g-column>
            </g-row>
        </g-card>
    </div>
</template>

<script>
    export default {
        name: 'BrandSwitcherItem',

        props: {
            displayName: {
                type: String,
                default: ''
            },
            current: {
                type: Boolean,
                default: false
            }
        },

        setup(props, { emit }) {
            const handleSwitch = () => {
                emit('switch');
            };

            return {
                handleSwitch
            };
        }
    };
</script>

<style lang="scss" scoped>
    ::v-deep .ant-card-body {
        padding: $g-spacing-5;

        .ant-row-flex {
            min-height: 40px;
        }
    }
</style>
